import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    light: true,
    themes: {
      dark: {
        darkbg: '#000000',
      },
      light: {
        lightbg: '#FAFAF7',
        primary: '#FF7B3F',
      },
    },
  },
});
